<ex-dropdown
  #dropdown
  size="small"
  noBorder
  noInput
  noChevron
  transparentStyle
  paddedItemsContainer
  disableAutoClose
  [overlayPositions]="[
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
  ]"
  [ngbTooltip]="(dropdown.show ? '' : 'common.share-tooltip') | translate"
  placement="bottom auto"
  tooltipClass="simple-tooltip fit"
  container="body"
  [openDelay]="500"
>
  <ng-template exDropdownDisplay>
    <div class="share-icon-container">
      <i class="ph-fill ph-share-network"></i>
    </div>
  </ng-template>

  <ng-template exDropdownContent>
    <div class="share-container">
      <app-sharing-panel
        [inputSize]="'small'"
        [module]="ExplainModuleEnum.TERRITORY_INTEL"
        [document]="document"
        (cancel)="dropdown.show = false"
        (share)="dropdown.show = false"
      ></app-sharing-panel>
    </div>
  </ng-template>
</ex-dropdown>
